import React from 'react';
import ServiceHero from '../../NewComponents/sections/ServiceHero';
import FacilityManagementSection from '../../NewComponents/sections/FacilityManagementSection';
import SecurityGuardingSection from '../../NewComponents/sections/SecurityGuardingSection';
import OutsourcingBenefitsTable from '../../NewComponents/sections/OutsourcingBenefitsTable';
import ServicePartnersSection from '../../NewComponents/sections/ServicePartnersSection';

const Services = () => (
  <div className="bg-white flex flex-col overflow-hidden">
    <ServiceHero />
    <FacilityManagementSection />
    <SecurityGuardingSection />
    <OutsourcingBenefitsTable />
    <ServicePartnersSection />
  </div>
);

export default Services;
